import { render } from "./GradientStop.vue?vue&type=template&id=5f4006b3"
import script from "./GradientStop.vue?vue&type=script&lang=js"
export * from "./GradientStop.vue?vue&type=script&lang=js"
script.render = render

export default script